/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsRuler: {
  name: 'ruler';
  data: string;
} = {
  name: 'ruler',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.586 2a2 2 0 0 1 2.828 0L22 5.586a2 2 0 0 1 0 2.828L8.414 22a2 2 0 0 1-2.828 0L2 18.414a2 2 0 0 1 0-2.828L15.586 2ZM7.5 12.914 5.914 14.5l1.793 1.793a1 1 0 1 1-1.414 1.414L4.5 15.914 3.414 17 7 20.586 20.586 7 17 3.414 11.914 8.5l1.793 1.793a1 1 0 0 1-1.414 1.414L10.5 9.914 8.914 11.5l.793.793a1 1 0 1 1-1.414 1.414l-.793-.793ZM18 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" fill="currentColor"/></svg>`,
};
